export const isLocalDev = (): boolean =>
  process.env.NEXT_PUBLIC_IS_LOCAL === 'true';

type LocalFeatureFlags = Record<string, boolean>;
export const getLocalFeatureFlags = async (): Promise<LocalFeatureFlags> => {
  if (!isLocalDev()) {
    return {};
  }

  try {
    const response = await fetch('/api/local-feature-flags');
    return response.ok ? await response.json() : {};
  } catch {
    return {};
  }
};

export const setLocalFeatureFlag = async (
  name: string,
  enabled: boolean,
): Promise<boolean> => {
  if (!isLocalDev()) {
    return false;
  }

  try {
    const response = await fetch('/api/local-feature-flags', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, enabled }),
    });
    return response.ok;
  } catch {
    return false;
  }
};

export const clearLocalFeatureFlags = async (): Promise<boolean> => {
  if (!isLocalDev()) {
    return false;
  }

  try {
    const response = await fetch('/api/local-feature-flags', {
      method: 'DELETE',
    });
    return response.ok;
  } catch {
    return false;
  }
};
